"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs — v1
 * API v1 documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfChangePhoneDto = instanceOfChangePhoneDto;
exports.ChangePhoneDtoFromJSON = ChangePhoneDtoFromJSON;
exports.ChangePhoneDtoFromJSONTyped = ChangePhoneDtoFromJSONTyped;
exports.ChangePhoneDtoToJSON = ChangePhoneDtoToJSON;
exports.ChangePhoneDtoToJSONTyped = ChangePhoneDtoToJSONTyped;
/**
 * Check if a given object implements the ChangePhoneDto interface.
 */
function instanceOfChangePhoneDto(value) {
    if (!('firebaseIdToken' in value) || value['firebaseIdToken'] === undefined)
        return false;
    return true;
}
function ChangePhoneDtoFromJSON(json) {
    return ChangePhoneDtoFromJSONTyped(json, false);
}
function ChangePhoneDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'firebaseIdToken': json['firebaseIdToken'],
    };
}
function ChangePhoneDtoToJSON(json) {
    return ChangePhoneDtoToJSONTyped(json, false);
}
function ChangePhoneDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'firebaseIdToken': value['firebaseIdToken'],
    };
}
